var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstantApprovals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "95px",
    viewBox: "0 0 79 95",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 15.6,
    cy: 15.6,
    r: 15.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upgrade-7",
    transform: "translate(-153.000000, -94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Upgrade/Instant-Approve",
    transform: "translate(113.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(40.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    fill: "#CCCCCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2261905,13.0625 C62.8515753,13.0625 66.6011905,16.784133 66.6011905,21.375 L66.6011905,86.2916748 C66.6011905,90.8825417 62.8515753,94.6041748 58.2261905,94.6041748 L8.77380172,94.6041748 C4.14841694,94.6041748 0.398801718,90.8825417 0.398801718,86.2916747 L0.398801718,21.3749996 C0.398801718,16.7841328 4.14841717,13.0625 8.77380172,13.0625 L15.9518017,13.0625 L15.9518017,17.0205 L8.77380172,17.0208333 C6.35098135,17.0208333 4.38689696,18.97026 4.38689696,21.3749996 L4.38689696,86.2916748 C4.38689696,88.6964146 6.35098112,90.6458414 8.77380172,90.6458414 L58.2261905,90.6458414 C60.6490111,90.6458414 62.6130952,88.6964146 62.6130952,86.2916748 L62.6130952,21.375 C62.6130952,18.9702602 60.6490111,17.0208333 58.2261905,17.0208333 L52.6428017,17.0205 L52.6428017,13.0625 L58.2261905,13.0625 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7559524,37.2083333 C13.6546703,37.2083333 12.7619048,36.3222302 12.7619048,35.2291667 C12.7619048,34.1361031 13.6546703,33.25 14.7559524,33.25 L52.7010282,33.25 C53.8023103,33.25 54.6950758,34.1361031 54.6950758,35.2291667 C54.6950758,36.3222302 53.8023103,37.2083333 52.7010282,37.2083333 L14.7559524,37.2083333 Z",
    id: "Line-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7559524,47.5 C13.6546703,47.5 12.7619048,46.6138969 12.7619048,45.5208333 C12.7619048,44.4277698 13.6546703,43.5416667 14.7559524,43.5416667 L52.7010282,43.5416667 C53.8023103,43.5416667 54.6950758,44.4277698 54.6950758,45.5208333 C54.6950758,46.6138969 53.8023103,47.5 52.7010282,47.5 L14.7559524,47.5 Z",
    id: "Line-17-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7559524,57 C13.6546703,57 12.7619048,56.1138969 12.7619048,55.0208333 C12.7619048,53.9277698 13.6546703,53.0416667 14.7559524,53.0416667 L52.7010282,53.0416667 C53.8023103,53.0416667 54.6950758,53.9277698 54.6950758,55.0208333 C54.6950758,56.1138969 53.8023103,57 52.7010282,57 L14.7559524,57 Z",
    id: "Line-17-Copy-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7559524,67.2916667 C13.6546703,67.2916667 12.7619048,66.4055636 12.7619048,65.3125 C12.7619048,64.2194364 13.6546703,63.3333333 14.7559524,63.3333333 L52.7010282,63.3333333 C53.8023103,63.3333333 54.6950758,64.2194364 54.6950758,65.3125 C54.6950758,66.4055636 53.8023103,67.2916667 52.7010282,67.2916667 L14.7559524,67.2916667 Z",
    id: "Line-17-Copy-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7559524,76.7916667 C13.6546703,76.7916667 12.7619048,75.9055636 12.7619048,74.8125 C12.7619048,73.7194364 13.6546703,72.8333333 14.7559524,72.8333333 L52.7010282,72.8333333 C53.8023103,72.8333333 54.6950758,73.7194364 54.6950758,74.8125 C54.6950758,75.9055636 53.8023103,76.7916667 52.7010282,76.7916667 L14.7559524,76.7916667 Z",
    id: "Line-17-Copy-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3095238,9.5 L19.1428571,9.5 C18.2618315,9.5 17.547619,10.2088825 17.547619,11.0833333 L17.547619,19.7916667 C17.547619,20.6661175 18.2618315,21.375 19.1428571,21.375 L48.6547619,21.375 C49.5357876,21.375 50.25,20.6661175 50.25,19.7916667 L50.25,11.0833333 C50.25,10.2088825 49.5357876,9.5 48.6547619,9.5 L38.2857143,9.5 L38.2857143,7.125 C38.2857143,4.93887287 36.5001832,3.16666667 34.297619,3.16666667 C32.0950549,3.16666667 30.3095238,4.93887287 30.3095238,7.125 L30.3095238,9.5 Z M34.297619,0 C37.9926321,0 41.0356072,2.77087255 41.4323782,6.33333333 L48.6547619,6.33333333 C51.2978389,6.33333333 53.4404762,8.45998077 53.4404762,11.0833333 L53.4404762,19.7916667 C53.4404762,22.4150192 51.2978389,24.5416667 48.6547619,24.5416667 L19.1428571,24.5416667 C16.4997801,24.5416667 14.3571429,22.4150192 14.3571429,19.7916667 L14.3571429,11.0833333 C14.3571429,8.45998077 16.4997801,6.33333333 19.1428571,6.33333333 L27.1628599,6.33333333 C27.5596309,2.77087255 30.602606,0 34.297619,0 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Tick",
    transform: "translate(45.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(2.400000, 2.400000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Maroon",
    mask: "url(#mask-2)",
    fill: "#710D0D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.400000, -2.400000)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 36
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M15.4890085,19.6330248 L23.2181738,12.4839618 C23.9561557,11.8013681 25.1077599,11.8462692 25.7903536,12.5842511 C26.4729473,13.3222331 26.4280462,14.4738373 25.6900642,15.156431 L16.6521219,23.5160424 C15.9249506,24.1886369 14.793433,24.1562782 14.1058877,23.4432263 L10.1099007,19.2989955 C9.41213391,18.5753429 9.43311855,17.4230548 10.1567712,16.7252881 C10.8804238,16.0275213 12.0327119,16.0485059 12.7304786,16.7721586 L15.4890085,19.6330248 Z",
    id: "Tick",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantApprovals);
export default __webpack_public_path__ + "static/media/instant_approvals.8a83961b974cc0247f1d6afda83c217e.svg";
export { ForwardRef as ReactComponent };